import { render, staticRenderFns } from "./contractDetail.vue?vue&type=template&id=6180bdf9&scoped=true"
import script from "./contractDetail.vue?vue&type=script&lang=js"
export * from "./contractDetail.vue?vue&type=script&lang=js"
import style0 from "./contractDetail.vue?vue&type=style&index=0&id=6180bdf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6180bdf9",
  null
  
)

export default component.exports